// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2026-08-12 01:38:49 +0200 (Wed, 12 Aug 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: s.bock $
//  Revision  : $Rev: 164835 $
//  Purpose   : search package
// =============================================================================
export const parts = true;
export const columns = true;
import * as views from './views';
export { views };
import * as actions from './actions';
export { actions };
import * as reducers from './reducers';
export { reducers };
